import React from 'react';
import { Grid, Typography, Paper, IconButton, Tooltip, Checkbox, FormControlLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useDispatch, useSelector } from 'react-redux'
import CachedIcon from '@mui/icons-material/Cached';
import { obtenerlistaperiodo, obtenerperiododispercion } from '../../../Redux/DepartamentosDucks'

export default function SelectPeriodo(props) {
    const dispatch = useDispatch()
    const { dis } = props
    const { obtenerPeriodohijo } = props;
    const { obtenerPeriodohijo2 } = props;
    const { dep } = props
    const [finmes, SetFinMes] = React.useState(false)
    const periodos = useSelector(store => store.depta.periodo)
    const periododispercion = useSelector(store => store.depta.periododispercion)

    const handleChange = (event) => {
        obtenerPeriodohijo(event.target.value)
    };
    const handleChange2 = (event) => {
        obtenerPeriodohijo2(event.target.value)
    };
    const handleChangeNoperiodo = (event) => {
        obtenerPeriodohijo2({
            idperiodo: 0, numeroperiodo: '', ejercicio: '', fechainicio: '', fechafin: ''
        }
        )
    };
    const handleChangelistaperiododisper = (event) => {
        dispatch(obtenerperiododispercion(props.bd, dep.iddepartamento))
    };

    const handleChangelistaperiodo = (event) => {
        dispatch(obtenerlistaperiodo(props.bd))
    };


    if (dis === true) {
        return (
            <>
                <Grid container alignItems="center" justifyContent="center" flexDirection='column'>
                    <Grid item md={5} >
                        <Typography variant='h3'>
                            Selección de periodo
                        </Typography>
                    </Grid>
                    <Grid item md={10} padding={2} >
                        <Typography variant='h6'>
                            Selecciona dos periodos de nomina para generar el archivo de dispersion
                        </Typography>
                    </Grid>
                    <Grid item md={10}>
                        <FormControlLabel
                            label="Fin del mes"
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    value={finmes}
                                    checked={finmes}
                                    onChange={e => (SetFinMes(!finmes), handleChangeNoperiodo)}
                                    color="primary"
                                />
                            }
                        />
                    </Grid>
                    <br />

                    <Grid item md={10} component={Paper} variant="outlined" padding={5}>

                        <Typography variant='h6' >
                            Selecciona  el periodo de nomina<Tooltip title="Actualizar lista">
                                <IconButton aria-label="delete" onClick={(e) => handleChangelistaperiododisper()}>
                                    <CachedIcon />
                                </IconButton>
                            </Tooltip>
                        </Typography>

                        <FormControl variant='standard' sx={{ m: 1, minWidth: 300 }} fullWidth>
                            <InputLabel id="demo-simple-select-filled-label">Periodo</InputLabel>
                            <Select
                                fullWidth
                                labelId="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                value={props.periodo}
                                onChange={handleChange}
                            >
                                <MenuItem value=" ">
                                    <em>None</em>
                                </MenuItem>
                                {periododispercion.map((row, Index) => (
                                    <MenuItem key={Index} value={periododispercion[Index]}>
                                        <>
                                            {row.numeroperiodo} - ({row.fechainicio}  -  {row.fechafin} )
                                        </>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <br />
                    {finmes === true ? <>

                    </> :
                        <>
                            <Grid item md={10} component={Paper} variant="outlined" padding={5}>

                                <Typography variant='h6' >
                                    Selecciona  el periodo de nomina<Tooltip title="Actualizar lista">
                                        <IconButton aria-label="delete" onClick={(e) => handleChangelistaperiododisper()}>
                                            <CachedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Typography>

                                <FormControl variant='standard' sx={{ m: 1, minWidth: 300 }} fullWidth>
                                    <InputLabel id="demo-simple-select-filled-label">Periodo</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-simple-select-filled-label"
                                        id="demo-simple-select-filled"
                                        value={props.periodo2}
                                        onChange={handleChange2}
                                    >
                                        <MenuItem value=' '>
                                            <em>None</em>
                                        </MenuItem>
                                        {periododispercion.map((row, Index) => (
                                            <MenuItem key={Index} value={periododispercion[Index]}>
                                                <>
                                                    {row.numeroperiodo} - ({row.fechainicio}  -  {row.fechafin} )
                                                </>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid> </>}
                </Grid>
            </>
        )
    }
    return (
        < >
            <Grid container alignItems="center" justifyContent="center" flexDirection='column'>
                <Grid item md={5} >
                    <Typography variant='h3'>
                        Selección de periodo
                    </Typography>
                </Grid>
                <Grid item md={5} >
                    <Typography variant='h6'>
                        Selecciona el periodo de la nominas para capturar la incidencia
                    </Typography>
                </Grid>

                <br />
                <Grid item md={10} component={Paper} variant="outlined" padding={5}>

                    <Typography variant='h6' >
                        Selecciona  el periodo de nomina<Tooltip title="Actualizar lista">
                            <IconButton aria-label="delete" onClick={(e) => handleChangelistaperiodo()}>
                                <CachedIcon />
                            </IconButton>
                        </Tooltip>
                    </Typography>

                    <FormControl variant='standard' sx={{ m: 1, minWidth: 300 }} fullWidth>
                        <InputLabel id="demo-simple-select-filled-label">Periodo</InputLabel>
                        <Select
                            fullWidth
                            labelId="demo-simple-select-filled-label"
                            id="demo-simple-select-filled"
                            value={props.periodo}
                            onChange={handleChange}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {periodos.map((row, Index) => (
                                <MenuItem key={Index} value={row}>
                                    <>
                                        Semana {row.numeroperiodo} - ({row.fechainicio}  -  {row.fechafin} )
                                    </>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </ >
    );
}